import {
    REQUEST_MOVIES_BY_CINEMA,
    REQUEST_MOVIES_BY_CINEMA_SUCCEEDED,
    REQUEST_MOVIES_BY_CINEMA_FAILED,
    REQUEST_MOVIES_BY_CINEMA_ID,
    REQUEST_MOVIES_BY_CINEMA_ID_SUCCEEDED,
    REQUEST_MOVIES_BY_CINEMA_ID_FAILED,
    REQUEST_SORT_TYPES_CINEMA_SCHEDULE,
    SORT_TYPES_CINEMA_SCHEDULE_SUCCEEDED,
    SORT_TYPES_CINEMA_SCHEDULE_FAILED,
    REQUEST_SCHEDULE_MOVIES_ALL,
    SCHEDULE_MOVIES_ALL_SUCCEEDED,
    SCHEDULE_MOVIES_ALL_FAILED,
} from './types';

export const requestMoviesByAllCinemas = (payload) => ({
    type: REQUEST_MOVIES_BY_CINEMA,
    payload,
});

export const requestMoviesByCinemaSuccess = (payload) => ({
    type: REQUEST_MOVIES_BY_CINEMA_SUCCEEDED,
    payload,
});

export const requestMoviesByCinemaFailed = (payload) => ({
    type: REQUEST_MOVIES_BY_CINEMA_FAILED,
    payload,
});

export const requestMoviesByCinemaId = (payload) => ({
    type: REQUEST_MOVIES_BY_CINEMA_ID,
    payload,
});

export const requestMoviesByCinemaIdSuccess = (payload) => ({
    type: REQUEST_MOVIES_BY_CINEMA_ID_SUCCEEDED,
    payload,
});

export const requestMoviesByCinemaIdFailed = (payload) => ({
    type: REQUEST_MOVIES_BY_CINEMA_ID_FAILED,
    payload,
});

export const requestSortTypesOnCinemaSchedule = (payload) => ({
    type: REQUEST_SORT_TYPES_CINEMA_SCHEDULE,
    payload,
});

export const requestSortTypesOnCinemaScheduleSuccess = (payload) => ({
    type: SORT_TYPES_CINEMA_SCHEDULE_SUCCEEDED,
    payload,
});

export const requestSortTypesOnCinemaScheduleFailed = (payload) => ({
    type: SORT_TYPES_CINEMA_SCHEDULE_FAILED,
    payload,
});


export const requestScheduleMoviesAll = (payload) => ({
    type: REQUEST_SCHEDULE_MOVIES_ALL,
    payload,
});

export const requestScheduleMoviesAllSuccess = (payload) => ({
    type: SCHEDULE_MOVIES_ALL_SUCCEEDED,
    payload,
});

export const requestScheduleMoviesAllFailed = (payload) => ({
    type: SCHEDULE_MOVIES_ALL_FAILED,
    payload,
});



// WEBPACK FOOTER //
// ./src/SHARED/actions/schedule.actions.js